import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { isNullOrUndefined, LocalizationPipe } from '@abp/ng.core';
import { FaIconComponent, SizeProp } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { ButtonFillMode, ButtonThemeColor, KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { KENDO_TOOLTIP } from '@progress/kendo-angular-tooltip';

import { CypressNamePipe } from '@nexweb/shared/ui/pipes/cypress-name';

@Component({
  selector: 'nexweb-button',
  standalone: true,
  templateUrl: './button.component.html',
  imports: [KENDO_TOOLTIP, KENDO_BUTTON, LocalizationPipe, CypressNamePipe, KENDO_LOADER, FaIconComponent],
})
export class ButtonComponent implements OnInit {
  @Input() disabled;
  @Input() icon?: IconDefinition;
  @Input() title: string;
  @Input() primary: boolean;
  @Input() class: string;
  @Input() look: string;
  @Input() size: SizeProp;
  @Input() tooltip: string;
  @Input() showLoader: boolean;
  @Input() fillMode: ButtonFillMode;
  @Input() themeColor: ButtonThemeColor;
  @Output() clicked = new EventEmitter<unknown>();

  public cypressMarker: string;

  constructor() {}

  ngOnInit(): void {
    if (isNullOrUndefined(this.fillMode)) {
      this.fillMode = (this.look || 'clear') as ButtonFillMode;

      if (this.primary) {
        this.fillMode = 'solid' as ButtonFillMode;
      }
    }

    if (isNullOrUndefined(this.themeColor)) {
      this.themeColor = 'secondary';
    }
  }

  public clickHandler(event: unknown) {
    this.clicked.emit(event);
  }
}
